import React, { memo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserExperience } from "@microdoing/shared/services/user/selectors";
import { getFirstTeamRankings } from "@microdoing/shared/services/ranking/selectors";
getUserExperience;
import { getCampaignTeamRankingRequest } from "@microdoing/shared/services/ranking/actions";
import {
  getCampaignId,
  getTeamId,
} from "@microdoing/shared/services/userCampaign/selectors";
import { Box, MainTitle } from "app/components/common";
import i18n from "@microdoing/shared/i18n";
import { Loading } from "app/components/common";
import TeamRankingRow from "./TeamRankingRow";
import { useScreenLoading } from "app/scenes/UserProfile/hooks";
import { useNavigation } from "@react-navigation/native";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import SeeAll from "app/components/common/SeeAll";

interface IProps {}

const TeamRankingBox = ({}: IProps) => {
  const [isScreenLoading] = useScreenLoading();

  const firstTeamRankings = useSelector(getFirstTeamRankings);
  const campaignId = useSelector(getCampaignId);
  const experience = useSelector(getUserExperience);
  const teamId = useSelector(getTeamId);

  const dispatch = useDispatch();
  const navigation = useNavigation();

  useEffect(() => {
    dispatch(getCampaignTeamRankingRequest({ campaignId, page: 0, limit: 10 }));
  }, [campaignId, getCampaignTeamRankingRequest, experience]);

  const navigateRankings = () => navigation.navigate("TeamRanking");

  if (isScreenLoading) return <Loading size={30} />;

  return (
    <Box
      backgroundColor="neutral.white"
      borderRadius={10}
      paddingTop="sm"
      marginTop={isWebDesktop ? "null" : "sm"}
      paddingBottom="xs"
    >
      <Box
        flex={1}
        paddingHorizontal="m"
        alignItems="center"
        justifyContent="space-between"
        flexDirection="row"
        marginBottom="s"
      >
        <MainTitle variant="l6-bold">{i18n.t("teams")}</MainTitle>
        <SeeAll navigationRoute="TeamRanking" />
      </Box>
      {firstTeamRankings.map((team, index) => {
        return (
          <TeamRankingRow
            {...team}
            rank={index + 1}
            key={team._id}
            teamName={team.name}
            points={team.points}
            isUserTeam={team._id === teamId}
            onPress={navigateRankings}
          />
        );
      })}
    </Box>
  );
};

export default memo(TeamRankingBox);
